import fr from 'facet-rest';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';
import { SearchableSelect } from 'Components/UI/Select/SearchableSelect';
import { FDCheckboxInput } from '@facet-wealth/design';
import MultiselectField from 'Components/ComponentLibrary/Components/Uncategorized/MultiselectField';

export const metaOverrideSet = fr.metaOverride({ BaseOverrideNoHidden })
  .typeOverride('picklist', {
    hidden: false,
    _component: () => SearchableSelect,
    _customProps: {
      clearable: true,
      disabled: false,
    },
  })
  .typeOverride('multipicklist', {
    _component: () => MultiselectField,
    _customProps: {
      helperText: '',
    },
  })
  .typeOverride('bool', {
    hidden: false,
    _component: () => FDCheckboxInput,
    _customProps: {
      helperText: '',
    },
  });
